import { useStore } from 'hooks/useStore';
import { AddOpportunityPayload } from 'Interfaces/BDPortalInterfaces';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { bdportalScreenServices } from 'services/bdportalScreenServices';

const useParallelIterations = ({
  conceptName,
  toggleModalVisibility,
  sourceId,
}: {
  conceptName: string;
  toggleModalVisibility: () => void;
  sourceId: number;
}) => {
  const {
    BDPortalStore: {
      board,
      handleFetchAllConceptDetailsForSearch,
      fetchDropdownBoardDetails,
    },
  } = useStore();
  const [isOpportunityAddLoading, setIsOpportunityAddLoading] = useState(false);
  const navigate = useNavigate();
  const [newOpportunity, setNewOpportunity] = useState<AddOpportunityPayload>({
    iteration_type: '',
    molecule_and_form: '',
    source_id: sourceId,
    stage_id: 1,
    status_id: 1,
  });

  // const createNewFreshIteration = () => {};
  const createNewFreshIteration = async () => {
    setIsOpportunityAddLoading(true);
    try {
      const payload = {
        ...newOpportunity,
        iteration_type: board,
        molecule_and_form: conceptName,
      };

      // check if source for the new opportuity is not 0
      if (payload.source_id === 0) {
        return toast.error('Please select a source for the new opportunity');
      }

      const res = await bdportalScreenServices.addOpportunity(payload);

      // this needs to changed later
      if (res.message.toLocaleLowerCase().includes('already exists')) {
        setAddOpportunityResponse(res);
      } else {
        setNewOpportunity({
          iteration_type: '',
          molecule_and_form: '',
          source_id: 1,
          stage_id: 1,
          status_id: 1,
        });
        handleFetchAllConceptDetailsForSearch();
        fetchDropdownBoardDetails();
        if (res?.new_opportunity_details) {
          navigate(
            `/bdportal/optracker/board?opportunityIdParam=${res?.new_opportunity_details.OpportunityID}&opportunityIterationIdParam=${res?.new_opportunity_details.IterationID}`
          );
        }
        toggleModalVisibility();
      }
    } catch (_err) {
      toast.error('Failed to create opportunity, please verify Molecule Name entered is valid');
    } finally {
      setIsOpportunityAddLoading(false);
    }
  };

  return {
    createNewFreshIteration,
    isOpportunityAddLoading,
  };
};

export default useParallelIterations;
